export default {"src":"/_next/static/media/hotline.6883e0fa.svg","height":26,"width":26};